import { useQuery } from '@tanstack/react-query';
import { getDasPolicyStatementSummary } from '../../../services/das.service';

export const useDasPolicyStatementSummary = (filters = null, enabled = false) => {
  return useQuery({
    queryKey: [
      'dasStatementSummary',
      filters?.policyNumber || filters?.policy_number || 'all',
      filters?.statement_type || 'summary',
      filters?.format || 'pdf'
    ],
    queryFn: () => getDasPolicyStatementSummary(filters),
    enabled: !!enabled && !!filters,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
    retry: 1,
    onError: (error) => {
      console.error('Error fetching DAS policy statement summary:', error);
    }
  });
};
